
import { defineComponent } from "vue";

export default defineComponent({
  name: "Alert",
  props: {
    text: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: "primary",
    },
  },
});
